/// <reference path="../Div.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Container extends Div {

        /**
         *
         * @param elements
         */
        public replaceChildren(elements: Tag[]) {
            this.clear();
            this.appendChildren(elements);
        }

        /**
         *
         * @param elements
         */
        public appendChildren(elements: Tag[]) {
            const me = this;
            elements.forEach((element: Tag) => {
                me.appendChild(element);
            });
        }

        /**
         *
         * @param tag
         */
        public replaceByTag(tag: Tag) {
            this.clear();
            const me = this;
            if (tag) {
                setTimeout(() => {
                    me.clear();
                    me.appendChild(tag);
                }, 0);
            }
        }

        protected createByType(data: Map<any, any>, main: Tag) {
            const t = data.get("t");
            let tag: List | any = null;
            switch (t) {
                case "__":
                    tag = new Div(data.get("d"));
                    tag.addClass("t1");
                    break;
                default:
                    super.createByType(data, main);
                    break;
            }
            if (tag) {
                main.appendChild(tag);
            }
        }
    }
}
